export default __webpack_public_path__ + "static/media/github_black.3fc2cd08.svg";